import { render, staticRenderFns } from "./LoginSSO.vue?vue&type=template&id=7043f45f"
import script from "./LoginSSO.vue?vue&type=script&lang=js"
export * from "./LoginSSO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports